var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useApolloClient, useMutation } from '@apollo/client';
import { CreatePromptDocument, UpdatePromptDocument, } from './query.gql';
export function useUpsertPrompt() {
    const { cache } = useApolloClient();
    const [createMutation, createState] = useMutation(CreatePromptDocument);
    const [updateMutation, updateState] = useMutation(UpdatePromptDocument);
    const loading = createState.loading || updateState.loading;
    const error = createState.error || updateState.error;
    const handleUpdateCache = (data) => {
        if (data === null || data === void 0 ? void 0 : data.documentAssistantPrompt) {
            cache.modify({
                fields: {
                    documentAssistantPromptsByUser(existing = [], { toReference, isReference }) {
                        const existingRefs = existing;
                        const ref = toReference(data.documentAssistantPrompt);
                        if (isReference(ref)) {
                            return [
                                ref,
                                // eslint-disable-next-line no-underscore-dangle
                                ...existingRefs.filter((existingRef) => existingRef.__ref !== ref.__ref),
                            ];
                        }
                        return existing;
                    },
                },
            });
        }
    };
    const handleCreatePrompt = (variables) => __awaiter(this, void 0, void 0, function* () {
        return createMutation({
            variables,
            update(_, { data }) {
                return handleUpdateCache(data);
            },
        });
    });
    const handleUpdatePrompt = (variables) => __awaiter(this, void 0, void 0, function* () {
        return updateMutation({
            variables: {
                id: variables.id,
                input: variables.input,
            },
            update(_, { data }) {
                return handleUpdateCache(data);
            },
        });
    });
    return { create: handleCreatePrompt, update: handleUpdatePrompt, loading, error };
}
